import { Placeholder } from "reactstrap";

const Avatar = (props) => {
    const datatestid = props.datatestid ? props.datatestid : 'avatar';

    if (!props.email) {
        return (
            <div data-testid={datatestid} className={props.alignTop ? "d-flex align-items-start flex-wrap gap-2" : "d-flex align-items-center flex-wrap gap-2"}>
                <Placeholder animation="wave"></Placeholder>
            </div>
        );
    }

    const email = props.email.toLowerCase();
    let initials = getInitialsFromEmail(email);

    const uid = props.uid || 'no email';
    const myHash = getHashOfString(uid);

    const normalizeHash = (hash, min, max) => Math.floor((hash % (max - min)) + min);

    const hRange = [0, 360];
    const sRange = [50, 75];
    const lRange = [25, 60];

    const h = normalizeHash(myHash, hRange[0], hRange[1]);
    const s = normalizeHash(myHash, sRange[0], sRange[1]);
    const l = normalizeHash(myHash, lRange[0], lRange[1]);

    const getBackgroundColor = `hsl(${h}, ${s}%, ${l}%)`;

    return (
        <div data-testid={datatestid} className={props.alignTop ? "d-flex align-items-start flex-wrap gap-2" : "d-flex align-items-center flex-wrap gap-2"}>
            <div className={
                props.small ? "circle-small" :
                props.large ? "circle-large" :
                props.xlarge ? "circle-xlarge" : "circle"
            }
                style={{ backgroundColor: getBackgroundColor, color: getTextColor(getBackgroundColor) }}>
                {initials}
            </div>
        </div>
    );
};

/**
 * Extracts initials based on email format.
 * - First character of the email
 * - Character after the first dot (`.`) in the email
 */
function getInitialsFromEmail(email) {
    let initials = email.charAt(0).toUpperCase(); // First character

    const dotIndex = email.indexOf(".");
    if (dotIndex !== -1 && email.length > dotIndex + 1) {
        initials += email.charAt(dotIndex + 1).toUpperCase();
    } else {
        initials += email.charAt(1)?.toUpperCase() || ""; // Fallback if no dot
    }

    return initials;
}

function getHashOfString(str) {
    let hash = 0;
    for (let i = 0; i < str.length; i++) {
        hash = str.charCodeAt(i) + ((hash << 5) - hash);
    }
    return Math.abs(hash);
}

function getTextColor(color) {
    const rgb = parseInt(color.slice(1), 16);
    const r = (rgb >> 16) & 0xff;
    const g = (rgb >> 8) & 0xff;
    const b = (rgb >> 0) & 0xff;
    const luminance = 0.2126 * r + 0.7152 * g + 0.0722 * b;
    return luminance > 128 ? '#000000' : '#ffffff';
}

export default Avatar;
